import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import ReactMde from "react-mde";
import * as Showdown from "showdown";

const HomepageInfo = () => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [titles, setTitles] = useState({
    id: 0,
    title1: '',
    title2: '',
    title3: '',
  });
  const [heroSubheader, setHeroSubheader] = useState('');
  const [heroBody, setHeroBody] = useState('');
  const [pageSubheader, setPageSubheader] = useState('');
  const [pageBody, setPageBody] = useState('');
  const [selectedTab, setSelectedTab] = useState("write");
  const [reviewHeader, setReviewHeader] = useState('');

  const [imageType, setImageType] = useState("homepage_hero_image.jpg");
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');

  const fileInputRef = useRef();

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    loadTitles();
    loadFiles();
  }, []);

  const loadFiles = () => {
    setFiles(['homepage_hero_image.jpg', 'homepage_kiosk_image.jpg']);
    setIsLoading(false);
  };

  const loadTitles = () => {
    axios.get("/api/homepage").then((result) => {
      const data = result.data?.[0];
      setTitles({
        id: data?.id,
        title1: data?.title1,
        title2: data?.title2,
        title3: data?.title3,
      });
      setHeroSubheader(data?.hero_subheader);
      setHeroBody(data?.hero_body);
      setPageSubheader(data?.page_subheader);
      setPageBody(data?.page_body);
      setReviewHeader(data?.review_header);
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!selectedFile) return alert("Please select a file first.");

    setIsUploading(true);
    const formData = new FormData();
    formData.append('upload_file', selectedFile);
    formData.append('fileName', imageType);

    axios
      .post("/api/file/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((result) => {
        if (result.status === 200) {
          alert(result.data);
          loadFiles();
          setSelectedFile(null);
          setPreviewUrl('');
          fileInputRef.current.value = '';
        }
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    const data = {
      ...titles,
      hero_subheader: heroSubheader,
      hero_body: heroBody,
      page_subheader: pageSubheader,
      page_body: pageBody,
      review_header: reviewHeader,
      img_url: `homepage_hero_image.jpg`
    };

    axios.post("/api/homepage", data)
      .then((result) => {
        const data = result.data?.[0];
        setTitles({
          id: data?.id,
          title1: data?.title1,
          title2: data?.title2,
          title3: data?.title3,
        });
        setHeroSubheader(data?.hero_subheader);
        setHeroBody(data?.hero_body);
        setPageSubheader(data?.page_subheader);
        setPageBody(data?.page_body);
        setReviewHeader(data?.review_header);
      })
      .finally(() => {
        alert('Homepage updated successfully');
        setIsSubmitting(false);
      });
  };

  return (
    <div className="mt-3">
      <h1 className="text-center">Homepage</h1>

      <div className="col-6 mx-auto my-3">
        <h4>Image Upload</h4>
        <div className="p-3 border">
          <div className="mb-3">
            <div className="form-check">
              <input
                type="radio"
                className="form-check-input"
                id="heroImage"
                name="imageType"
                value="homepage_hero_image.jpg"
                checked={imageType === 'homepage_hero_image.jpg'}
                onChange={(e) => setImageType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="heroImage">
                Hero Image
              </label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                className="form-check-input"
                id="kioskImage"
                name="imageType"
                value="homepage_kiosk_image.jpg"
                checked={imageType === 'homepage_kiosk_image.jpg'}
                onChange={(e) => setImageType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="kioskImage">
                Kiosk Image
              </label>
            </div>
          </div>

          <input
            type="file"
            accept="image/jpeg"
            name="upload_file"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
          <input
            type="button"
            onClick={onSubmit}
            className="float-right"
            name="btn_upload_file"
            value={isUploading ? "Uploading" : "Upload"}
            disabled={isUploading}
          />
        </div>
      </div>

      {isLoading ? (
        <div className="spinner-border text-center mx-auto d-block" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div className="col-6 mx-auto">
          <div style={{ maxHeight: "70vh", overflow: "auto" }}>
            <table className="table table-striped table-bordered">
              <thead className="thead-dark" style={{ position: "sticky", top: 0 }}>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Preview</th>
                </tr>
              </thead>
              <tbody>
                {files.map((file, index) => (
                  <tr key={`${file}-${index}`}>
                    <td>
                      <span>{file === 'homepage_hero_image.jpg' ? 'Hero Image' : 'Kiosk Image'}</span>
                    </td>
                    <td>
                      <img
                        src={file === imageType && previewUrl ? previewUrl : cmsLink() + "/img/" + file}
                        width="120"
                        height="80"
                        loading="lazy"
                        alt={file}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="container my-4">
            <h2 className="text-center">Titles</h2>

            {["title1", "title2", "title3"].map((key) => (
              <div className="row py-2" key={key}>
                <div className="col-2 text-right">{key}:</div>
                <div className="col-10 text-left">
                  <input
                    type="text"
                    className="form-input w-100"
                    value={titles[key]}
                    onChange={(e) => setTitles(prev => ({ ...prev, [key]: e.target.value }))}
                  />
                </div>
              </div>
            ))}

            <h2 className="text-center mt-5">Header and Page</h2>
            <div className="row py-2">
              <div className="col-2 text-left">Hero Subheader:</div>
              <div className="col-10 text-left">
                <input
                  type="text"
                  className="form-input w-100"
                  value={heroSubheader}
                  onChange={(e) => setHeroSubheader(e.target.value)}
                />
              </div>
            </div>

            <div className="row py-2">
              <div className="col-2 text-right">Hero Body:</div>
              <div className="col-10 text-left">
                <ReactMde
                  value={heroBody}
                  onChange={setHeroBody}
                  selectedTab={selectedTab}
                  onTabChange={setSelectedTab}
                  generateMarkdownPreview={(markdown) => Promise.resolve(converter.makeHtml(markdown))}
                />
              </div>
            </div>

            <div className="row py-2">
              <div className="col-2 text-right">Page Subheader:</div>
              <div className="col-10 text-left">
                <input
                  type="text"
                  className="form-input w-100"
                  value={pageSubheader}
                  onChange={(e) => setPageSubheader(e.target.value)}
                />
              </div>
            </div>

            <div className="row py-2">
              <div className="col-2 text-right">Page Body:</div>
              <div className="col-10 text-left">
                <ReactMde
                  value={pageBody}
                  onChange={setPageBody}
                  selectedTab={selectedTab}
                  onTabChange={setSelectedTab}
                  generateMarkdownPreview={(markdown) => Promise.resolve(converter.makeHtml(markdown))}
                />
              </div>
            </div>

            <div className="row py-2">
              <div className="col-2 text-left">Seed Review Header:</div>
              <div className="col-10 text-left">
                <input
                  type="text"
                  className="form-input w-100"
                  value={reviewHeader}
                  onChange={(e) => setReviewHeader(e.target.value)}
                />
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-12 text-right">
                <button className="btn btn-primary px-4 mr-4" onClick={handleSubmit} disabled={isSubmitting}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const cmsLink = () => {
  return process.env.REACT_APP_ENV === "production"
    ? "https://www.spareboxstorage.com"
    : "https://staging.spareboxstorage.com";
};

const converter = new Showdown.Converter({
  tables: true,
  simplifiedAutoLink: true,
  strikethrough: true,
  tasklists: true,
});

export default HomepageInfo;
